/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-explicit-any */
// ini udah ada di shared utils
import moment_ from 'moment';
const moment = moment_;

export class Formatter {
    static toDate(date: any) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }

    static toDateWithFormat(date: any, format: string) {
        moment.locale('id');
        return moment(date).format(format);
    }

    static coutDate(FirstHour: any, LastHour: any) {
        if (FirstHour == undefined || FirstHour == '') {
            FirstHour = new Date();
        }
        if (LastHour == undefined || LastHour == '') {
            LastHour = new Date();
        }

        const HourNow: any = new Date(FirstHour);
        const HourLast: any = new Date(LastHour);
        const diffMs = HourLast - HourNow;
        const diffHrs = Math.floor((diffMs % 86400000) / 3600000); //Jam
        const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); //Menit
        const TotalJamMenit = diffHrs + ' Jam, ' + diffMins + ' Menit ';

        return TotalJamMenit;
    }

    static countAge(dateDay: any, target: any) {
        target = moment(target);
        const months = target.diff(moment(dateDay), 'months', true);
        const birthSpan = {
            year: Math.floor(months / 12),
            month: Math.floor(months) % 12,
            day: Math.round((months % 1) * target.daysInMonth())
        };
        // you can adjust below logic as your requirements by yourself
        return `${birthSpan.year} tahun ${birthSpan.month} bulan ${birthSpan.day} hari`;
    }

    static currency(data: any, currency: any) {
        // Use toLocaleString for safe number formatting without regex
        const num = Number.parseFloat(data);
        const formatted = num.toLocaleString('id-ID', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        return currency + ' ' + formatted;
    }

    static priceOnly(value: any) {
        value = String(value);
        const x = value.split('.');
        let x1 = x[0];
        const x2 = x.length > 1 ? '.' + x[1] : '';
        const rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    static toCurrency(money: number) {
        return money.toLocaleString('id-ID', {
            style: 'currency',
            currency: 'IDR'
        });
    }

    static toCurrencyWithSeparator(money: number, separator: string = '.') {
        const formattedCurrency = new Intl.NumberFormat('id-ID', { maximumSignificantDigits: 3 }).format(money);

        return formattedCurrency.replace(/\./g, separator);
    }

    static dateToTimeStamp(date: any) {
        return moment(date).format('x');
    }

    static dateToTimeStampX(date: any) {
        return moment(date).format('X');
    }

    static unixTimestamp(data: string) {
        moment(data).unix().toString();
    }
    static getDay(date: string, lang?: string) {
        return moment(date).locale(lang ?? '').format('dddd');
    }
    static getDateTime(date: string, lang?: string) {
        return moment(date).locale(lang ?? '').format('ll');
    }
    static customDateTime(date: string, lang?: string) {
        return moment(date).locale(lang ?? '').format('dddd, Do-MM-yyyy');
    }
    static getHoursOnly(date: any, lang?: string) {
        return moment(date).locale(lang ?? '').format('LT');
    }
    static getTimeOnly(date: any) {
        return moment(date).format('time');
    }
    static countDays(first: number, second: number) {
        return Math.round((second - first) / (1000 * 60 * 60 * 24));
    }
}
